export default "/packs/images/yoga2~c0bb7739791061feb06e794a9d755a81.jpg";